import * as React from 'react'

export type IconSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | number | string

const SIZE_MAP: Record<string, number> = {
  xs: 16,
  sm: 20,
  md: 24,
  lg: 28,
  xl: 32,
}

export function resolveSize(size: IconSize): number | string {
  if (typeof size === 'string' && size in SIZE_MAP) {
    return SIZE_MAP[size]
  }
  return size
}

export interface IconProps extends React.SVGProps<SVGSVGElement> {
  size?: IconSize
}

export const Icon: React.FC<IconProps> = ({
  size = 'md',
  children,
  viewBox = '0 0 24 24',
  ...rest
}) => {
  const resolved = resolveSize(size)
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={resolved}
      height={resolved}
      viewBox={viewBox}
      fill="none"
      stroke="none"
      aria-hidden="true"
      {...rest}
    >
      {children}
    </svg>
  )
}
